import React, { FC } from 'react';
import {
  Accordion as BaseAccordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  Typography,
} from '@material-ui/core';
import { Link as BaseLink } from 'react-router-dom';
import { Link } from '@material-ui/core';

import { AccordionData } from './model/accordionModel';
import useMainProgressContext from '../progress/MainProgress/context/MainProgressContext';

interface AccordionProps {
  data: AccordionData[];
  expanded: boolean;
  expandIcon: object | null;
  className?: string;
}

const Accordion: FC<AccordionProps> = (props) => {
  const { show } = useMainProgressContext();

  return (
    <>
      {props.data.map(({ title, details }) => (
        <BaseAccordion className={props.className} aria-label="accordion" key={title} expanded={props.expanded}>
          <AccordionSummary expandIcon={props.expandIcon}>
            <Typography>{title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {details
                .sort((a, b) => a.label.localeCompare(b.label))
                .map(({ label, to }) => (
                  <ListItem key={to}>
                    <Link
                      color="inherit"
                      to={to}
                      onClick={() => {
                        show();
                      }}
                      component={BaseLink}
                    >
                      {label}
                    </Link>
                  </ListItem>
                ))}
            </List>
          </AccordionDetails>
        </BaseAccordion>
      ))}
    </>
  );
};

export default Accordion;
